import {Platform, StyleProp, ViewStyle} from 'react-native';
import Settings from 'src/Settings';
import Styles from 'src/components/Styles';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import Localized from 'src/constants/AppStrings';
import AVTouchableOpacity from 'src/components/elements/AVTouchableOpacity';
import {FundingDescriberProps} from 'src/components/elements/funding/descriptor/DescriptorType';

export function fundAutoReloadTxtStyleDescriptor(): {
  [index: string]: number | string;
} {
  return {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f7,
    fontFamily: Styles.FontFamily.latoRegular,
    fontWeight: '400',
    textDecorationLine: 'underline',
    textTransform: 'capitalize',
  };
}

export function getFundAccountTabContainerStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    container: {
      ...(Platform.OS === 'web' && {
        flex: 1,
      }),
      height: Settings.isNewUI() ? 450 : 360,
      backgroundColor: Styles.white,
      paddingBottom: Styles.Spacing.m4,
      paddingHorizontal: Settings.isNewUI()
        ? Styles.Spacing.m0
        : Styles.Spacing.m3,
      paddingTop: Settings.isNewUI() ? Styles.Spacing.m2 : Styles.Spacing.m1,
    },
  };
}

export function closeExpressFundingTemplateDescriptor(
  props?: FundingDescriberProps,
): JSX.Element {
  return (
    <AVTouchableOpacity
      style={{
        alignItems: 'flex-end',
        width: Styles.Spacing.m4 + Styles.Spacing.m3,
        height: Styles.Heights.touchTargetHeight0,
        justifyContent: 'center',
      }}
      accessibilityHint="Double tap to close the funding modal"
      aria-label="Cancel"
      accessibilityRole="button"
      accessibilityLabel="Cancel"
      onPress={() => props?.close()}
      role="button"
    >
      <FontAwesome5Pro
        name="times"
        size={Styles.Fonts.f3}
        color={Styles.darkColor}
        light
        style={{
          marginRight: Styles.Spacing.m1,
        }}
      />
    </AVTouchableOpacity>
  );
}

export function getModalTexts(): {
  [index: string]: number | string;
} {
  return {
    fundModalReloadHeader: Localized.Labels.edit_auto_reload,
  };
}

export function fundSwitchStyleDescriptor(): {
  [index: string]: number | string | Array<{scaleX?: number; scaleY?: number}>;
} {
  return {
    transform: [
      {
        scaleX: 0.85,
      },
      {
        scaleY: 0.85,
      },
    ],
  };
}

export function fundingSwitchTrackColorDescriptor(): string {
  return Styles.primaryColor;
}

export function getAcntFundingHeaderStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    headerNewContainer: {},
  };
}

export function getExpressFundingStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    paymentNewContainer: {
      marginHorizontal: Settings.isNewUI()
        ? Styles.Spacing.m3
        : Styles.Spacing.m0,
    },
    container: {
      paddingTop: Settings.isNewUI() ? Styles.Spacing.m3 : Styles.Spacing.m1,
      //borderRadius: Settings.isNewUI() ? 10 : 0,
      ...(Platform.OS === 'web' && {
        flex: 1,
      }),
      backgroundColor: Styles.white,
      paddingHorizontal: Settings.isNewUI()
        ? Styles.Spacing.m0
        : Styles.Spacing.m3,
    },
    autoReloadContainerHeihgt: {
      height: Settings.isNewUI() ? 500 : 410,
    },
    rewardsAutoReloadContainerHeihgt: {
      height: Settings.isNewUI() ? 600 : 410,
    },
    rewardsAutoReloadText: {
      alignSelf: 'left',
      color: Styles.black,
      fontSize: Styles.Fonts.f1,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
      fontStyle: 'italic',
      marginTop: Styles.Fonts.f1,
    },
    topContainer: {
      marginLeft: Settings.isNewUI()
        ? Styles.Spacing.m0
        : Styles.Spacing.m4 + Styles.Spacing.m3,
    },
    toggleLabel: {
      alignSelf: 'center',
      color: Styles.darkColor,
      fontSize: Settings.isNewUI() ? Styles.Fonts.f7 : Styles.Fonts.f1,
      fontWeight: '400',
      fontFamily: Styles.FontFamily.latoRegular,
    },
    headerNewUIText: {
      color: Styles.darkColor,
      fontFamily: Styles.FontFamily.latoRegular,
    },
    backButton: {
      zIndex: 1,
      paddingTop: Styles.Spacing.m2,
      paddingBottom: Styles.Spacing.m2,
      paddingLeft: 10,
      paddingRight: 10,
      position: 'absolute',
    },
    bottomBtnContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      flex: 1,
    },
    saveButton: {
      zIndex: 1,
      paddingTop: Styles.Spacing.m2,
      paddingBottom: Styles.Spacing.m2,
      paddingLeft: 10,
      paddingRight: 10,
      right: 25,
      position: 'absolute',
    },
  };
}

export function getAmericanExpressRightIcon(
  issuer: string,
): StyleProp<ViewStyle> {
  switch (issuer.toLowerCase()) {
    case 'american-express':
    case 'american express':
    case 'americanexpress':
    case 'amex':
      return {
        borderRadius: 0,
        width: 100,
        marginRight: 20,
        top: 2,
      };
  }
  return {
    width: 100,
    marginRight: Styles.Spacing.m4,
    top: 2,
  };
}

export default {
  getFundAccountTabContainerStyleDescriptor,
  getModalTexts,
  fundSwitchStyleDescriptor,
  fundingSwitchTrackColorDescriptor,
  fundAutoReloadTxtStyleDescriptor,
  getExpressFundingStyleDescriptor,
  getAmericanExpressRightIcon,
};
